import { render, staticRenderFns } from "./sensitivewords.vue?vue&type=template&id=4dedd844&scoped=true&"
import script from "./sensitivewords.vue?vue&type=script&lang=ts&"
export * from "./sensitivewords.vue?vue&type=script&lang=ts&"
import style1 from "./sensitivewords.vue?vue&type=style&index=1&id=4dedd844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dedd844",
  null
  
)

export default component.exports